export const GEMINI_1 = 'gemini_1';
export const GEMINI_2 = 'gemini_2';
export const SAGITTARIUS = 'sagitário';
export const CASSIOPEIA = 'cassiopeia';
export const ANDROMEDA = 'andrômeda';
export const ORION = 'órion';
export const AQUARIUS = 'aquário';
export const CAPRICORN = 'capricórnio';
export const BOREALIS = 'boreal';